import { Component, Inject, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DetailsPdpmComponent } from '../detailsPdpmcomponent/detailsPdpmcomponent.component';
import { DetailsKeyServicesComponent } from '../detailsKeyServices/detailsKeyServices.component';

@Component({
  selector: 'app-pdpmSummary',
  templateUrl: './pdpmSummary.component.html',
  styleUrls: ['./pdpmSummary.component.scss']
})

export class PDPMSummaryComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any = [] = [];
  spinner: boolean = false;
  OfficeIDList: any = [] = [];
  myOfficeID: any;
  pdpmData: any = [] = [];
  componentList: any[] = [];
  NTAPointsBreakdown: any = [] = [];
  @ViewChild('keyServicesHeading')
  keyServicesHeading!: ElementRef;
  PDPMKeyServices: any = [] = [];

  constructor(private dialog: MatDialog,public dialogRef: MatDialogRef<PDPMSummaryComponent>,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }

  }



  ngOnInit(): void {
    this.pdpmData = this.data.pdpmData;

    this.NTAPointsBreakdown = this.pdpmData?.PDPMComponentBreakdown?.NTA?.NTAPointsBreakdown || [];

    this.PDPMKeyServices = this.pdpmData?.PDPMKeyServices ?? [];

    // Create dynamic component list
    this.componentList = Object.entries(this.pdpmData.PDPMComponentBreakdown)
      .filter(([key]) => key !== 'AssessmentIndicator')
      .map(([key, value]: any) => ({
        title: key,
        icon: this.getIcon(key),
        color: this.getColor(key),
        data: value
      }));
  }

  ngAfterViewInit() {
    if (this.data.openFrom == "KeyServices") {
      setTimeout(() => {
        this.keyServicesHeading.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 500);
    }

  }


  getIcon(type: string): string {
    switch (type) {
      case 'PT':
        return '↗';
      case 'OT':
        return '⌂';
      case 'SLP':
        return '◉';
      case 'Nursing':
        return '⚕';
      case 'NTA':
        return '♥';
      case 'Assessment_Indicator':
        return '📝';
      default:
        return '•';
    }
  }

  getColor(type: string): string {
    switch (type) {
      case 'PT':
        return 'blue';
      case 'OT':
        return 'purple';
      case 'SLP':
        return 'green';
      case 'Nursing':
        return 'yellow';
      case 'NTA':
        return 'pink';
      default:
        return 'gray';
    }
  }

  get totalPoints(): number {
    return this.NTAPointsBreakdown?.reduce(
      (sum: any, item: any) => sum + (+item.Points || 0),
      0
    ) || 0;
  }

  close() {
    this.dialogRef.close();
  }

  onPDPMClick(){
     const dialogRef = this.dialog.open(DetailsPdpmComponent, {
      data: {
        pdpmData:this.componentList,       
      },
      width: '90vw',
      maxWidth: '1500px',
      maxHeight: '95vh',
      panelClass: 'pdpm-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
       
      }
    });
  }

   onkeyServicesClick(){
     const dialogRef = this.dialog.open(DetailsKeyServicesComponent, {
      data: {
        PDPMKeyServices:this.PDPMKeyServices,        
      },
      width: '90vw',
      maxWidth: '1500px',
      maxHeight: '95vh',
      panelClass: 'pdpm-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
       
      }
    });
  }

}
